import { gql } from '@apollo/client';

export const GET_PARAGRAPHS = gql`
  query GetParagraphs {
    paragraphs {
      id
      title
      subtitle
      hskLevel
      timeMinutes
      charCount
      sentences {
        zh
        py
        en
        hint
        audio
      }
      referenceTranslation
      createdAt
      updatedAt
    }
  }
`;

export const GET_PARAGRAPH = gql`
  query GetParagraph($id: ID!) {
    paragraph(id: $id) {
      id
      title
      subtitle
      hskLevel
      timeMinutes
      charCount
      sentences {
        zh
        py
        en
        hint
        audio
      }
      referenceTranslation
    }
  }
`;
